export const darkTokens = {
  "--bg-deep": "#0B1120",
  "--bg-surface": "#111827",
  "--bg-raised": "#1A2332",
  "--bg-hover": "#1E293B",
  "--bg-active": "#253347",
  "--border-subtle": "rgba(148,163,184,0.08)",
  "--border-mid": "rgba(148,163,184,0.15)",
  "--border-strong": "rgba(148,163,184,0.25)",
  "--text-primary": "#F1F5F9",
  "--text-secondary": "#94A3B8",
  "--text-tertiary": "#64748B",
  "--text-muted": "#475569",
  "--accent": "#06D6A0",
  "--accent-dim": "rgba(6,214,160,0.15)",
  "--accent-glow": "rgba(6,214,160,0.3)",
  "--signal-blue": "#38BDF8",
  "--signal-amber": "#FBBF24",
  "--signal-rose": "#FB7185",
  "--signal-violet": "#A78BFA",
  "--signal-emerald": "#34D399",
  "--chart-1": "#06D6A0",
  "--chart-2": "#38BDF8",
  "--chart-3": "#A78BFA",
  "--chart-4": "#FBBF24",
  "--chart-5": "#FB7185",
  "--archie-gradient": "linear-gradient(135deg,#6366F1 0%,#8B5CF6 40%,#A78BFA 100%)",
  "--archie-bg": "rgba(99,102,241,0.08)",
  "--archie-border": "rgba(139,92,246,0.25)",
  "--archie-text": "#A78BFA",
} as const;

export const lightTokens = {
  "--bg-deep": "#F8FAFC",
  "--bg-surface": "#FFFFFF",
  "--bg-raised": "#F1F5F9",
  "--bg-hover": "#E2E8F0",
  "--bg-active": "#CBD5E1",
  "--border-subtle": "rgba(15,23,42,0.06)",
  "--border-mid": "rgba(15,23,42,0.12)",
  "--border-strong": "rgba(15,23,42,0.2)",
  "--text-primary": "#0F172A",
  "--text-secondary": "#475569",
  "--text-tertiary": "#64748B",
  "--text-muted": "#94A3B8",
  "--accent": "#059669",
  "--accent-dim": "rgba(5,150,105,0.1)",
  "--accent-glow": "rgba(5,150,105,0.2)",
  "--signal-blue": "#0284C7",
  "--signal-amber": "#D97706",
  "--signal-rose": "#E11D48",
  "--signal-violet": "#7C3AED",
  "--signal-emerald": "#059669",
  "--chart-1": "#059669",
  "--chart-2": "#0284C7",
  "--chart-3": "#7C3AED",
  "--chart-4": "#D97706",
  "--chart-5": "#E11D48",
  "--archie-gradient": "linear-gradient(135deg,#6366F1 0%,#8B5CF6 40%,#A78BFA 100%)",
  "--archie-bg": "rgba(99,102,241,0.06)",
  "--archie-border": "rgba(139,92,246,0.2)",
  "--archie-text": "#7C3AED",
} as const;

export type V2TokenMap = typeof darkTokens;

export const FONT_SANS = "'DM Sans', -apple-system, sans-serif";
export const FONT_DISPLAY = "'Fraunces', Georgia, serif";
export const FONT_MONO = "'JetBrains Mono', monospace";

export const RAIL_WIDTH_COLLAPSED = 64;
export const RAIL_WIDTH_EXPANDED = 210;
export const DETAIL_PANE_WIDTH = 480;
export const ARCHIE_PANEL_WIDTH = 380;
